import React, {useCallback, useRef, useState} from 'react'

import EntitySelectorSearch from "../../search/search"
import EntitySelectorTabs from "../../content/tabs"
import EntitySelectorListTab from "../list-tab"
import EntitySelectorTasksList from "./list"
import {EntitySelectorEntityType, EntitySelectorListType} from "../../@const"
import {entitySelectorLoadTaskItems} from "./load-tasks"
import {MenuItemConfig} from "../../../../../layout/top/header/h-menu/h-menu-item-2"
import {useEntitySelectorContext} from "../../context"

const TASK_TABS: MenuItemConfig[] = [
    {id: EntitySelectorListType.BROWSE, label: 'Browse'},
    {id: EntitySelectorListType.RECENT, label: 'Recent'},
]

// const debug = "EntitySelectorTasks"
const debug = false

export default function EntitySelectorTasks() {
    const context                   = useEntitySelectorContext()

    const [search, setSearch]       = useState('')
    const [listType, setListType]   = useState(EntitySelectorListType.BROWSE)

    const listRef                   = useRef<any>()
    const searchRef                 = useRef<any>()

    const onSearchChanged = useCallback((search:string)=>{
        setSearch(search)
    }, [])

    const onCreateNew = useCallback(()=>{
        context.onCreateNew?.(EntitySelectorEntityType.TASK)
        return
    }, [context])

    const onTypeChanged = useCallback((type:EntitySelectorListType)=>{
        setListType(type)
        searchRef.current?.reset()
    }, [])

    const onKeyDown = useCallback((event: any)=>{
        listRef.current?.onKeyDown(event)
    }, [])

    // A query has no tree to browse, so it always lands in the flat list -- the
    // same rule the task finder applied before Browse / Recent became tabs.
    const showFlatList = !!search || listType === EntitySelectorListType.RECENT

    debug && console.log(debug, 'render', listType, search, showFlatList)

    return (
        <>
            <EntitySelectorSearch
                ref             = {searchRef}
                onKeyDown       = {onKeyDown}
                onSearchChanged = {onSearchChanged}
            />

            {!search &&
                <EntitySelectorTabs
                    tabs        = {TASK_TABS}
                    currentId   = {listType}
                    onSelect    = {onTypeChanged}
                    onCreateNew = {context.onCreateNew ? onCreateNew : undefined}
                    createLabel = "New task"
                />
            }

            {showFlatList &&
                <EntitySelectorListTab
                    ref             = {listRef}
                    search          = {search}
                    titleLabel      = "Task"
                    dateLabel       = "Last opened"
                    noItemsMessage  = "No tasks found"
                    loadItems       = {entitySelectorLoadTaskItems}
                />
            }

            {!showFlatList &&
                <EntitySelectorTasksList ref={listRef}/>
            }
        </>
    )
}
